import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { IconButtonComponent } from '@fcom/ui-components/components/buttons/icon-button/icon-button.component';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { CheckboxInputComponent } from '@fcom/ui-components/components/forms/checkbox-input/checkbox-input.component';
import { ComboBoxComponent } from '@fcom/ui-components/components/forms/combo-box/combo-box.component';
import { HeadingTagComponent } from '@fcom/ui-components/components/headers/heading-tag/heading-tag.component';
import { LinkComponent } from '@fcom/ui-components/components/link/link.component';
import { LoaderComponent } from '@fcom/ui-components/components/loader/loader.component';
import { MenuListComponent } from '@fcom/ui-components/components/notifications/menu-list/menu-list.component';
import { ModalComponent } from '@fcom/ui-components/components/modal/modal.component';
import { NotificationComponent } from '@fcom/ui-components/components/notifications/notification/notification.component';
import { RadioItemGroupComponent } from '@fcom/ui-components/components/forms/radio-item-group/radio-item-group.component';
import { StepperComponent } from '@fcom/ui-components/components/stepper/stepper.component';
import { SelectInputComponent } from '@fcom/ui-components/components/forms/select-input/select-input.component';
import { TextInputComponent } from '@fcom/ui-components/components/forms/text-input/text-input.component';
import { ClickOutsideDirective } from '@fcom/ui-components/directives/click-outside/click-outside.directive';
import { TrapFocusDirective } from '@fcom/ui-components/directives/trap-focus/trap-focus.directive';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';

import { ComponentsModule } from '../components/components.module';
import { NavigationTriggerModule } from '../components/header/navigation-trigger.module';
import { GtmModule } from '../gtm/gtm.module';
import { PipesModule } from '../pipes/pipes.module';
import { LoginButtonComponent } from './components/login-button.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginIframeComponent } from './components/login-iframe.component';
import { LoginWidgetComponent } from './components/login-widget/login-widget.component';
import { ProfileQuickViewComponent } from './components/profile-quick-view/profile-quick-view.component';
import { LoginCardComponent } from './components/login-card/login-card.component';
import { JoinFormComponent } from './components/join-form/join-form.component';
import { LoginFormContainerComponent } from './components/login-form-container/login-form-container.compontent';
import { DirectiveModule } from '../directives/directive.module';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { FinFormsModule } from '../forms/forms.module';
import { LoyaltyEmailChangeVerificationMfaFormComponent } from './components/loyalty-email-change-verification-mfa-form/loyalty-email-change-verification-mfa-form.component';
import { SoftEnforceMfaComponent } from './components/soft-enforce-mfa/soft-enforce-mfa.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    GtmModule,
    PipesModule,
    NavigationTriggerModule,
    UiTranslateModule,
    DirectiveModule,
    ButtonComponent,
    IconButtonComponent,
    IconComponent,
    CheckboxInputComponent,
    ComboBoxComponent,
    HeadingTagComponent,
    LinkComponent,
    LoaderComponent,
    MenuListComponent,
    ModalComponent,
    NotificationComponent,
    RadioItemGroupComponent,
    StepperComponent,
    SelectInputComponent,
    TextInputComponent,
    ClickOutsideDirective,
    TrapFocusDirective,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    FinFormsModule,
    CommonServiceFormsModule,
  ],
  declarations: [
    LoginIframeComponent,
    LoginButtonComponent,
    ProfileQuickViewComponent,
    LoginWidgetComponent,
    LoginFormContainerComponent,
    LoginCardComponent,
    LoginFormComponent,
    JoinFormComponent,
    LoginDialogComponent,
    LoyaltyEmailChangeVerificationMfaFormComponent,
    SoftEnforceMfaComponent,
  ],
  exports: [
    LoginIframeComponent,
    LoginButtonComponent,
    ProfileQuickViewComponent,
    LoginWidgetComponent,
    LoginFormContainerComponent,
    LoginCardComponent,
    LoginFormComponent,
    JoinFormComponent,
    LoginDialogComponent,
    LoyaltyEmailChangeVerificationMfaFormComponent,
    SoftEnforceMfaComponent,
  ],
  providers: [],
})
export class LoginModule {}
